export default __webpack_public_path__ + "static/media/poppins-regular.40db4e34.ttf";